import "./CustomerDetailsModalV2.scss";

import { Modal, Nav } from "react-bootstrap";
import { useEffect, useState } from "react";

import CustomerAnamneseTab from "./tabs/CustomerAnamneseTab";
import CustomerClubsTab from "./tabs/CustomerClubsTab";
import CustomerHeaderCard from "./CustomerHeaderCard";
import CustomerInsightsTab from "./tabs/CustomerInsightsTab";
import CustomerNotesTab from "./tabs/CustomerNotesTab";
import CustomerPackageSalesTab from "./tabs/CustomerPackageSalesTab";
import CustomerVisitsTab from "./tabs/CustomerVisitsTab";
import StatPills from "./StatPills";
import { formatPhone } from "../../../../commons/util/HallAppUtil";
import useCustomerClubs from "./hooks/useCustomerClubs";
import useCustomerHistory from "./hooks/useCustomerHistory";
import useCustomerHistoryView from "./hooks/useCustomerHistoryView";
import useCustomerPackages from "./hooks/useCustomerPackegs";

function CustomerDetailsModalV2({ closeShow, show, customer }) {
  const [activeTab, setActiveTab] = useState("visits");
  const [q, setQ] = useState("");
  const [period, setPeriod] = useState("ALL"); // ALL | 30D | 90D | 12M
  const [groupMode, setGroupMode] = useState("MONTH"); // MONTH | NONE
  const [sortMode, setSortMode] = useState("DATE_DESC"); // DATE_DESC | DATE_ASC | VALUE_DESC | VALUE_ASC

  const { isLoading, history, getHistory } = useCustomerHistory(customer?.id);
  const { isLoading: isLoadingClubs, clubs, getClubs } = useCustomerClubs(customer?.id);
  const { isLoading: isLoadingPackages, packages, getPackages } = useCustomerPackages(customer?.id);

  useEffect(() => {
    if (!show) return;

    setActiveTab("visits");
    setQ("");
    setPeriod("ALL");
    setGroupMode("MONTH");
    setSortMode("DATE_DESC");

    getHistory();
  }, [show, getHistory]);

  const { filteredHistory, groupedHistory, stats } = useCustomerHistoryView({
    history,
    q,
    period,
    groupMode,
    sortMode,
  });

  const copyPhone = async () => {
    try {
      const text = customer?.whatsapp ? formatPhone(customer.whatsapp) : "";
      if (!text) return;
      await navigator.clipboard.writeText(text);
      // HallAppToast.success("Número copiado!");
    } catch {
      // HallAppToast.error("Não foi possível copiar.");
    }
  };

  return (
    <Modal
      show={show}
      onHide={closeShow}
      centered
      scrollable
      size="lg"
      fullscreen
      contentClassName="hc-cd-modal"
    >
      <Modal.Header className="container hc-cd-header">
        <CustomerHeaderCard customer={customer} onClose={closeShow} onCopyPhone={copyPhone} />
      </Modal.Header>

      <Modal.Body className="hc-cd-body">
        <div className="container">
          {/* pills do topo */}
          <StatPills stats={stats} />

          {/* tabs */}
          <div className="hc-cd-tabs">
            <Nav variant="pills" activeKey={activeTab} onSelect={(k) => setActiveTab(k || "visits")}>
              <Nav.Item>
                <Nav.Link eventKey="visits">Visitas</Nav.Link>
              </Nav.Item>
              <Nav.Item>
                <Nav.Link eventKey="insights">Insights</Nav.Link>
              </Nav.Item>
              <Nav.Item>
                <Nav.Link eventKey="clubs">Clube de Assinaturas</Nav.Link>
              </Nav.Item>
              <Nav.Item>
                <Nav.Link eventKey="anamnese">Anamnese</Nav.Link>
              </Nav.Item>
              <Nav.Item>
                <Nav.Link eventKey="packages">Pacotes</Nav.Link>
              </Nav.Item>
            </Nav>
          </div>

          {/* conteúdo */}
          {activeTab === "visits" && (
            <CustomerVisitsTab
              isLoading={isLoading}
              q={q}
              setQ={setQ}
              period={period}
              setPeriod={setPeriod}
              groupMode={groupMode}
              setGroupMode={setGroupMode}
              sortMode={sortMode}
              setSortMode={setSortMode}
              filteredHistory={filteredHistory}
              groupedHistory={groupedHistory}
            />
          )}

          {activeTab === "clubs" && (
            <CustomerClubsTab
              customerId={customer?.id}
              show={show && activeTab === "clubs"}
              isLoading={isLoadingClubs}
              clubs={clubs}
              refresh={getClubs}
            />
          )}

          {activeTab === "insights" && <CustomerInsightsTab stats={stats} />}
          {activeTab === "anamnese" && <CustomerAnamneseTab customerWhatsapp={customer.whatsapp} />}

          {activeTab === "packages" && <CustomerPackageSalesTab customerId={customer?.id}
            show={show && activeTab === "packages"}
            isLoading={isLoadingPackages}
            packages={packages}
            refresh={getPackages} />}
        </div>
      </Modal.Body>
    </Modal>
  );
}

export default CustomerDetailsModalV2;
